function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M59.11 9.42a16.47 16.47 0 00-23.29 0l-3.86 3.87-3.89-3.87a16.48 16.48 0 00-23.3 23.31l26.35 26.35a1.16 1.16 0 001.64 0l26.35-26.35a16.48 16.48 0 000-23.31z",
  fill: "currentColor"
});

function SvgFavoritFull(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgdmlld0JveD0iMCAwIDY0IDY0Ij48dGl0bGU+ZmF2b3JpdC1mdWxsPC90aXRsZT48cGF0aCBkPSJNNTkuMTEsOS40MmExNi40NywxNi40NywwLDAsMC0yMy4yOSwwbDAsMC0zLjg2LDMuODdMMjguMDcsOS40MkExNi40OCwxNi40OCwwLDAsMCw0Ljc3LDMyLjczTDMxLjEyLDU5LjA4YTEuMTYsMS4xNiwwLDAsMCwxLjY0LDBMNTkuMTEsMzIuNzNhMTYuNDgsMTYuNDgsMCwwLDAsMC0yMy4zMVoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPjwvc3ZnPg==";
export { SvgFavoritFull as ReactComponent };